/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './data';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      buyerportal: {
        nested: {
          receiptlookup: {
            nested: {
              ReceiptLookupService: {
                methods: {
                  CreateReceiptLookupVerification: {
                    requestType:
                      '.squareup.buyerportal.receiptlookup.CreateReceiptLookupVerificationRequest',
                    responseType:
                      '.squareup.buyerportal.receiptlookup.CreateReceiptLookupVerificationResponse',
                  },
                  VerifyReceiptLookupCode: {
                    requestType:
                      '.squareup.buyerportal.receiptlookup.VerifyReceiptLookupCodeRequest',
                    responseType:
                      '.squareup.buyerportal.receiptlookup.VerifyReceiptLookupCodeResponse',
                  },
                  SearchReceipts: {
                    requestType:
                      '.squareup.buyerportal.receiptlookup.SearchReceiptsRequest',
                    responseType:
                      '.squareup.buyerportal.receiptlookup.SearchReceiptsResponse',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.ReceiptLookupService
) {
  $root.addJSON(jsonData);
}

/**
 * Account-less receipt lookup: OTP verification of an email/phone followed by a proof-gated
 * receipt search. All endpoints are unauthenticated (no buyer account required).
 *
 * SOURCE ReceiptLookupService @ squareup/buyerportal/receiptlookup/service.proto at 13:1
 */
export const ReceiptLookupService = $root.lookupService(
  'squareup.buyerportal.receiptlookup.ReceiptLookupService'
);
